var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercardLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 33,
    viewBox: "0 0 45 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.11719,
    width: 44,
    height: 30.7647,
    rx: 3.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7371 22.8913C21.17 24.2123 19.1372 25.0097 16.9158 25.0097C11.9594 25.0097 7.94141 21.0395 7.94141 16.1421C7.94141 11.2446 11.9594 7.27441 16.9158 7.27441C19.1372 7.27441 21.17 8.07184 22.7371 9.39278C24.3042 8.07184 26.3371 7.27441 28.5584 7.27441C33.5148 7.27441 37.5328 11.2446 37.5328 16.1421C37.5328 21.0395 33.5148 25.0097 28.5584 25.0097C26.3371 25.0097 24.3042 24.2123 22.7371 22.8913Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7373 22.8913C24.6669 21.2649 25.8905 18.8446 25.8905 16.1421C25.8905 13.4395 24.6669 11.0193 22.7373 9.39277C24.3044 8.07184 26.3372 7.27441 28.5586 7.27441C33.515 7.27441 37.533 11.2446 37.533 16.1421C37.533 21.0395 33.515 25.0097 28.5586 25.0097C26.3372 25.0097 24.3044 24.2123 22.7373 22.8913Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7371 22.8911C24.6667 21.2646 25.8903 18.8444 25.8903 16.1418C25.8903 13.4393 24.6667 11.0191 22.7371 9.39258C20.8075 11.0191 19.584 13.4393 19.584 16.1418C19.584 18.8444 20.8075 21.2646 22.7371 22.8911Z",
    fill: "#FF5E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLg);
export default __webpack_public_path__ + "static/media/mastercardLg.88b5df44.svg";
export { ForwardRef as ReactComponent };